<div class="redemption-dialog-header" [style.gap.px]="headerGap()">
  <div class="redemption-dialog-header__progress">
    <button
      mat-icon-button
      class="card-header-icon ac-icon-btn-sm"
      (click)="back.emit()"
      [style.visibility]="hideBack() ? 'hidden' : 'visible'"
    >
      <ac-icon iconKey="hr:arrow_left" [size]="26" />
    </button>
    <div class="redemption-dialog-header__progress-boxes" [class.redemption-dialog-header__center-content]="hideSteps()">
      @if (!hideSteps()) {
        @for (box of boxes; track $index) {
        <div
          class="progress-step {{
            $index === step() && stepColor() ? stepColor() : ''
          }}"
          [class.active]="$index <= step()"
        ></div>
        }
      } @else {
        <ng-content select=".center-content" />
      }
    </div>
    <button
      mat-icon-button
      class="card-header-icon ac-icon-btn-sm"
      (click)="close.emit()"
      [style.visibility]="hideClose() ? 'hidden' : 'visible'"
    >
      <ac-icon class="card-header-icon" iconKey="hr:xmark" [size]="18" />
    </button>
  </div>
  @if (!hideBalance()) {
  <div class="ac-ctr ac-flex" [style.height.px]="32">
    <div
      class="redemption-dialog-header__pill redemption-dialog-header__balance ac-title-md"
      [style.visibility]="typeof user()?.sc_balance !== 'undefined' ? 'visible' : 'hidden'"
    >
      @if (typeof typeof user()?.sc_balance !== 'undefined') { Redeemable
      Balance: {{ user()?.sc_balance | decimal : 2 + '-' + 2 }} SC }
    </div>
  </div>
  }
  <div class="ac-flex-col ac-gap-sm">
    @if (title()) {
    <div class="ac-headline-sm">{{ title() }}</div>
    } @if (subtitle()) {
    <div class="ac-label ac-body-md redemption-dialog-header__subtitle">
      {{ subtitle() }}
    </div>
    }
  </div>
</div>
